import { Directive, ElementRef, Renderer2, OnInit, HostListener, Input } from '@angular/core';

interface ICollapseSettings {
  hideArrow?: boolean;
  collapsed?: boolean;
}

@Directive({
  selector: '[appCollapse]',
  standalone: false
})
export class CollapseDirective implements OnInit {
  isDisabled = true;
  collapseSettings: ICollapseSettings;

  @Input() set appCollapse(collapseSettings: ICollapseSettings) {
    this.collapseSettings = collapseSettings;
    this.isDisabled = this.collapseSettings.collapsed;
    if (this.element.nativeElement) {
      this.renderer[this.collapseSettings && this.collapseSettings.collapsed === false ? 'removeClass' : 'addClass'](
        this.element.nativeElement.nextSibling,
        'collapsed'
      );

      this.renderer[this.collapseSettings && this.collapseSettings.collapsed === false ? 'addClass' : 'removeClass'](
        this.element.nativeElement,
        'collapse-out-header'
      );
    }
  }

  constructor(
    private readonly renderer: Renderer2,
    private readonly element: ElementRef
  ) {}

  ngOnInit() {
    this.handleCollapseClassToggle();
  }

  /**
   * Toggles the collapse classes based on certain conditions
   */
  handleCollapseClassToggle() {
    const isNullOrUndefined = (value) => value === undefined || value === null;

    if (
      !this.collapseSettings ||
      (this.collapseSettings &&
        (this.collapseSettings.collapsed || isNullOrUndefined(this.collapseSettings.collapsed)) &&
        this.element.nativeElement)
    ) {
      this.renderer['addClass'](this.element.nativeElement.nextSibling, 'collapsed');
      this.renderer['addClass'](this.element.nativeElement, 'collapse-in-header');
    }

    if (this.collapseSettings && this.collapseSettings.hideArrow && this.element.nativeElement) {
      this.renderer['addClass'](this.element.nativeElement, 'collapse-hide-arrow');
    }
  }

  @HostListener('click')
  onClick() {
    if (this.element.nativeElement) {
      this.renderer[this.isDisabled ? 'removeClass' : 'addClass'](this.element.nativeElement.nextSibling, 'collapsed');
      this.renderer[this.isDisabled ? 'addClass' : 'removeClass'](this.element.nativeElement, 'collapse-out-header');
    }
    this.isDisabled = !this.isDisabled;
  }
}
